import axios from 'axios';

import bugsnagClient from '@/bugsnag';
import { plugins } from '@/firebase';

const initialState = {
  loading: false,
  prompts: {},
  promptsMorning: {},
};

const actions = {
  async getPrompts({ commit }) {
    commit('setPromptsLoading', true);
    try {
      const [promptsDownloadUrl, morningPromptsDownloadUrl] = await Promise.all(
        [
          plugins.storage.ref('config/prompts.json').getDownloadURL(),
          plugins.storage.ref('config/promptsMorning.json').getDownloadURL(),
        ],
      );
      const [promptsResponse, morningPromptsResponse] = await Promise.all([
        axios.get(promptsDownloadUrl),
        axios.get(morningPromptsDownloadUrl),
      ]);
      commit('setPrompts', promptsResponse.data);
      commit('setPromptsMorning', morningPromptsResponse.data);
    } catch (err) {
      bugsnagClient.notify(err);
    } finally {
      commit('setPromptsLoading', false);
    }
  },
};

const getters = {
  promptsAreLoading: state => state.loading,
};

const mutations = {
  setPromptsLoading(state, payload) {
    state.loading = payload;
  },
  setPrompts(state, payload) {
    state.prompts = payload;
  },
  setPromptsMorning(state, payload) {
    state.promptsMorning = payload;
  },
};

export default {
  state: initialState,
  actions,
  getters,
  mutations,
};
